import React, { useEffect } from 'react'
import {
  updateSEO,
  ORGANIZATION_SCHEMA,
  WEBSITE_SCHEMA,
  SOFTWARE_SCHEMA,
  buildFAQSchema,
} from '../utils/seo';

import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import Features from '../components/Features';
import Testimonials from '../components/Testimonials';
import AppShowcase from '../components/AppShowcase';
import Footer from '../components/Footer';
import AboutSection from '../components/AboutSection';
import ContactUS from '../components/ContactUs';


const Home = () => {
  useEffect(() => {
    updateSEO({
      title: "SaferSavvy | AI-Powered University Transport Automation",
      description:
        "SaferSavvy is an AI-powered university transport automation platform. Real-time bus tracking, smart route optimization, automated attendance, and campus safety tools trusted by universities worldwide.",
      canonical: "/",
      keywords:
        "AI university transport, transport automation, university bus tracking, real-time bus tracker, smart routing, campus commute app, SaferSavvy, UET Lahore transport, automated attendance, driver management",
      jsonLd: [
        ORGANIZATION_SCHEMA,
        WEBSITE_SCHEMA,
        SOFTWARE_SCHEMA,
        buildFAQSchema([
          {
            question: "What is SaferSavvy?",
            answer:
              "SaferSavvy is an AI-powered university transport automation platform that provides real-time bus tracking, smart route optimization, automated attendance, and safety features for universities.",
          },
          {
            question: "How does SaferSavvy track buses in real-time?",
            answer:
              "SaferSavvy uses sub-meter GPS telemetry and AI-powered predictions to track every bus, every stop, every minute — giving students accurate arrival times and live map views.",
          },
          {
            question: "Is SaferSavvy free for students?",
            answer:
              "Yes, the SaferSavvy mobile app is free to download and use for all registered students. There are no ads or hidden charges.",
          },
          {
            question: "Which universities use SaferSavvy?",
            answer:
              "SaferSavvy is trusted by 100+ universities across 14 countries, including the University of Engineering and Technology (UET) Lahore.",
          },
          {
            question: "Can SaferSavvy optimize bus routes with AI?",
            answer:
              "Yes. SaferSavvy uses machine learning algorithms that analyze traffic patterns, demand data, and real-time conditions to optimize bus routes and reduce commute times by up to 35%.",
          },
        ]),
      ],
    });
  }, []);

  return (
    <div className="font-sans text-gray-800 dark:text-ink-100 dark:bg-ink-850 overflow-x-hidden">
                <Navbar />
                <Hero />

                <Features />
                <AboutSection />
                <HowItWorks />
                <Testimonials />
                <AppShowcase />
                <ContactUS />

                <Footer />
    </div>
  )
}

export default Home